const Currencies = () => import("Core/configuration/currencies/views/Currencies");
const CurrenciesForm = () => import("Core/configuration/currencies/views/CurrenciesForm");

export default {
    children: [
        {
            path: "currencies",
            name: "currencies",
            component: Currencies,
            meta: {
                requiresAuth: true,
                title: "lang.currencies",
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["configuration.read"],
            },
        },
        {
            path: "currency/:id?",
            name: "currency",
            component: CurrenciesForm,
            meta: {
                requiresAuth: true,
                title: "lang.currencies",
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["configuration.read"],
            },
        },
    ],
};
